import { LineHelper } from './line-helper';

export class ArrowHelper extends LineHelper {}
